// A copy of the favourites on the device ("Keep favorites offline"), one session host at a time.
const STORAGE_KEY = "favorites";
const MAX_CHARS = 1_500_000;

/** Saves the favourites shown for a session; returns false when they could not be stored. */
export function saveFavoritesCache(code, songs) {
  if (!code) return false;
  try {
    const json = JSON.stringify({ code, savedAt: Date.now(), songs: Array.isArray(songs) ? songs : [] });
    if (json.length > MAX_CHARS) return false;
    localStorage.setItem(STORAGE_KEY, json);
    return true;
  } catch {
    return false;
  }
}

/** The cached favourites for the session, or null when there are none (or they are for another session). */
export function loadFavoritesCache(code) {
  if (!code) return null;
  try {
    const entry = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return entry && entry.code === code && Array.isArray(entry.songs) ? entry.songs : null;
  } catch {
    return null;
  }
}

export function clearFavoritesCache() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing to clear
  }
}
